var exports = {
  "kL": "x112a1f60--e966d5--container",
  "iW": "x112a1f60--e966d5--main",
  "DD": "x112a1f60--e966d5--title",
  "WD": "x112a1f60--e966d5--labels",
  "HU": "x112a1f60--e966d5--aside",
};

module.exports = exports;
